import { useState } from 'react';
import style from './header.module.css'
import { AiOutlineUser, AiFillEdit, AiOutlineKey, AiOutlineLogout, } from 'react-icons/ai';
import { AvatarImage } from '../../common/AvatarImage';
import {
  logInfoAtom,
  userPermissionAtom,
  walletAtom,
  openPaymentInfoAtom,
  subscriptionsInfoAtom,
  balanceAtom
} from '../../store';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import groupWalletimg from '../../assets/groupWallet.png'
import wallet from '../../assets/wallet.png'
import { useNavigate } from 'react-router-dom';
import { logout } from '../../utils/net';
import Nav from "../../components/Nav";
import {checkMobile} from "../../utils/format";
import Restricted from "../../utils/restricted";

const BalanceComponent = ({ showSearchInput }) => {
  const balance = useRecoilValue(balanceAtom);
  const logInfo = useRecoilValue(logInfoAtom)
  const userPermission = useRecoilValue(userPermissionAtom)
  const setWallet = useSetRecoilState(walletAtom)
  const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  if (!logInfo) return null

  const openGroupWallet = () => {
    setOpenPaymentInfo({
      ...openPaymentInfo,
      group: true,
    })
    setWallet(old => !old)
  }

  const openWallet = () => {
    setOpenPaymentInfo({
      ...openPaymentInfo,
      group: false,
    })
    setWallet(old => !old)
  }

  return (
    <div className={`${style.balanceWrapper} ${showSearchInput ? style.hide : ""}`} >
      {userPermission.chatavatar_tab_group && (
        <div className={style.balance} onClick={openGroupWallet}>
          <img src={groupWalletimg} alt="groupWalletimg" />
          <div>{balance.groupBalance / 10}</div>
        </div>
      )}
      <div className={style.balance} onClick={openWallet}>
        <img src={wallet} alt='wallet' />
        <div>{(balance.selfBalance + subscriptionsInfo.wallet_balance) / 10}</div>
      </div>
    </div>
  )
}

const UserComponent = () => {
  const logInfo = useRecoilValue(logInfoAtom)
  const [showUserInfo, setShowUserInfo] = useState(false)
  const navi = useNavigate()
  const handlerLogin = () => {
    navi('/customlogin', { state: { type: 'signin', origin: location.pathname } })
  }

  const handlerShowUserInfo = () => {
    setShowUserInfo(true)

  }

  return (
    <div className={style.userWrapper}>
      {logInfo ? (
        <div className={style.userImg} onClick={handlerShowUserInfo} >
          <AvatarImage url={logInfo.avatar_url} />
        </div>
      ) : (
        <div className={style.unlogin} onClick={handlerLogin}>
          <AiOutlineUser size="20px" />
          <span>&nbsp; {!logInfo && localStorage.getItem('user_uuid') ? 'Loading' : 'Login'}</span>
        </div>
      )}
      {showUserInfo && <UserInfoComponent setShowUserInfo={setShowUserInfo} />}
    </div>
  )

}

const UserInfoComponent = ({ setShowUserInfo }) => {
  const logInfo = useRecoilValue(logInfoAtom)
  const navi = useNavigate()

  const handlerChangeTrigger = (target) => {
    navi('/customlogin', { state: { type: target, origin: location.pathname } })
  }

  const handleLogout = async () => {
    _czc.push(['_trackEvent', 'Pop Up', 'Logout Icon', 'User Panel']);
    localStorage.setItem('user_uuid', '');
    localStorage.setItem('privileged', '')
    localStorage.setItem('token', '');
    localStorage.setItem('group_uuid', '');
    await logout();
    window.location.href = location.pathname;
  };

  const handlerCloseUserInfo = () => {
    setShowUserInfo(false)
  }

  return (
    <div className={style.userInfoWrapper}>
      <div className={style.mask} onClick={handlerCloseUserInfo}></div>
      <div className={style.userInfoBox}>
        <div className={style.userInfoheader} >
          {logInfo && (
            <>
              <div className={style.userImg}>
                <AvatarImage url={logInfo.avatar_url} />
              </div>
              <div className={style.username}>
                {logInfo?.username?.length > 11 ? `${logInfo?.username?.slice(0, 11)}...` : logInfo?.username}
              </div>
              {logInfo.email
                && (
                  <div className={style.useremail}> {logInfo.email}</div>
                )}
            </>
          )}
        </div>

        <div className={style.userinfobtns}>
          <button onClick={handlerChangeTrigger.bind(null, 'changename')}>
            <AiFillEdit />
            <span>Change Username</span>
          </button>
          <button onClick={handlerChangeTrigger.bind(null, 'changeavatar')}>
            <AiOutlineUser />
            <span>Change Avatar</span>
          </button>
          <button onClick={handlerChangeTrigger.bind(null, 'changepassword')}>
            <AiOutlineKey />
            <span>Change Password</span>
          </button>
          <button className={style.logout} onClick={handleLogout}>
            <AiOutlineLogout />
            <span>Logout</span>
          </button>
        </div>

      </div>
    </div>
  )
}

// const SearchBox = ({ showSearchInput, setShowSearchInput }) => {
//   const searchInputRef = useRef(null)
//   const inputValue = useRef(null)
//   const setSearchKeyWord = useSetRecoilState(searchKeyWordAtom);
//   const setCardsType = useSetRecoilState(cardsTypeAtom);

//   const handlerClickSearch = () => {
//     if (showSearchInput) {
//       console.log('search----');
//       if (inputValue.current) {
//         setSearchKeyWord(inputValue.current)
//         setCardsType('Search')
//       }
//     }
//     setShowSearchInput(pre => !pre)
//   }

//   useEffect(() => {
//     if (showSearchInput) {
//       searchInputRef.current.focus()
//     } else {
//       searchInputRef.current.blur()
//     }
//   }, [showSearchInput])

//   const handlerChangeInput = (e) => {
//     inputValue.current = e.target.value
//   }

//   const handlerSubmit = () => {

//   }

//   const handlerClose = () => {
//     setShowSearchInput(false)
//   }

//   return (
//     <>
//       {showSearchInput && <div className={style.inputWrapper} onClick={handlerClose}></div>}
//       <form onSubmit={handlerSubmit} className={style.searchBox}>
//         <input
//           ref={searchInputRef}
//           onChange={handlerChangeInput}
//           className={style.searchInput}
//           type="text"
//           style={{ width: showSearchInput ? '65vw' : 0, padding: showSearchInput ? '0 20px' : "0" }} />
//         <div className={style.searchIcon} onClick={handlerClickSearch}>
//           <AiOutlineSearch size="1.2em" color='#fff' />
//         </div>
//       </form>
//     </>
//   )
// }

// const GenMeBox = () => {
//   return (
//     <div className={style.genmebox}>
//       <span className={style.genmeText}>GenMe</span>
//       <svg xmlns="http://www.w3.org/2000/svg" width="108" height="92" viewBox="0 0 108 92" fill="none">
//         <path d="M0 0H108V84C108 88.4183 104.418 92 100 92H0V0Z" fill="url(#paint0_linear_952_677)" />
//         <defs>
//           <linearGradient id="paint0_linear_952_677" x1="113.362" y1="92" x2="0" y2="92" gradientUnits="userSpaceOnUse">
//             <stop stopColor="#92A7DF" />
//             <stop offset="0.505208" stopColor="#BAB9EF" />
//             <stop offset="1" stopColor="#BFD8E3" />
//           </linearGradient>
//         </defs>
//       </svg>
//       <svg className={style.pointerIcon} xmlns="http://www.w3.org/2000/svg" width="33" height="34" viewBox="0 0 33 34" fill="none">
//         <g clipPath="url(#clip0_952_680)">
//           <path d="M14.0763 32.0453L14.0622 32.0207C14.0433 31.9867 14.0103 31.9433 13.9815 31.905L13.9716 31.8884C13.9569 31.8667 13.9393 31.8435 13.9281 31.8218L13.8558 31.714L13.8474 31.7039L10.3051 26.0859C9.88859 25.4278 9.73747 24.6282 9.88385 23.8571C10.0181 23.0906 10.4414 22.4099 11.0613 21.964C11.4605 21.6797 11.9262 21.5106 12.4102 21.4743C12.8942 21.4381 13.3788 21.536 13.8137 21.7578L13.8137 12.368C13.8094 10.7353 15.0038 9.40424 16.4712 9.40424C17.9366 9.40424 19.133 10.7353 19.133 12.3702L19.133 15.3868C19.3486 15.313 19.5742 15.2752 19.8014 15.2747C20.4951 15.2747 21.1509 15.619 21.6129 16.2136C21.973 15.9669 22.3945 15.8323 22.8269 15.8259C23.3247 15.8285 23.8071 16.0042 24.196 16.3243C24.5014 16.5703 24.7577 16.8886 24.9438 17.2582C25.16 17.1881 25.3847 17.1497 25.6101 17.1497C26.9757 17.1497 28.0858 18.4808 28.0858 20.1157L28.0858 28.0066C28.0858 29.7522 27.3366 31.6815 26.1774 32.9243C25.5315 33.6166 24.8364 34 24.2136 34L16.646 34C15.2277 34 14.5909 32.9163 14.0763 32.0453ZM24.3673 32.5416C24.5969 32.5416 25.1678 32.1466 25.7274 31.272C26.3277 30.328 26.6717 29.198 26.6717 28.1759L26.6717 20.0593C26.6717 19.3959 26.2743 18.8201 25.8214 18.8201C25.7213 18.8205 25.6229 18.8466 25.535 18.896L25.535 21.7347L25.5322 21.7347C25.4999 22.2107 25.1291 22.5796 24.6819 22.5818C24.2332 22.5818 23.8604 22.2056 23.8302 21.7354L23.8288 21.7354L23.8288 19.2715L23.7776 18.5799C23.7333 17.9636 23.3507 17.4608 22.9231 17.4608C22.7335 17.4608 22.539 17.5693 22.3852 17.7502L22.3852 20.8203C22.3838 21.3223 22.0019 21.7282 21.53 21.7296C21.0596 21.7274 20.6784 21.3216 20.677 20.8203L20.677 18.1191L20.6131 17.8037C20.5077 17.2785 20.1539 16.8835 19.7937 16.8835C19.5479 16.8835 19.3022 17.0629 19.1358 17.3544L19.1084 20.4L19.1084 21.5451C19.1084 21.9893 18.7665 22.3546 18.3494 22.3546L18.1647 22.3546C17.7456 22.3546 17.405 21.9893 17.405 21.5451L17.405 12.4042L17.4001 12.0816C17.4001 11.3979 16.9339 10.8445 16.3575 10.8445C15.7817 10.8445 15.3155 11.3994 15.3155 12.0816L15.3527 20.965C15.3548 20.9917 15.3555 21.0192 15.3555 21.0467L15.3555 24.5711C15.3485 25.0247 15.0304 25.4045 14.6085 25.4624C14.4014 25.4882 14.1922 25.4353 14.0203 25.3136C13.8484 25.1918 13.7254 25.0096 13.6746 24.8012L13.3538 23.805C13.2707 23.6706 13.1624 23.5546 13.0351 23.4639C12.9079 23.3733 12.7644 23.3097 12.613 23.277C12.4628 23.2454 12.3078 23.2457 12.1577 23.2778C12.0075 23.3098 11.8653 23.3731 11.7396 23.4636C11.206 23.8456 11.0648 24.6153 11.4222 25.1839L15.074 30.966L15.0859 30.9819L15.1308 31.0528L15.187 31.1418C15.2214 31.1997 15.2586 31.2547 15.2916 31.2973L15.3155 31.3292L15.3331 31.369C15.9018 32.3369 16.1208 32.5459 16.5527 32.5459L24.3673 32.5459L24.3673 32.5402L24.3673 32.5416Z" fill="white" />
//           <path d="M11.0585 11.9362C11.0585 12.4353 10.6653 12.8404 10.1808 12.8404L5.61699 12.8404C5.38425 12.8404 5.16106 12.7451 4.9965 12.5755C4.83195 12.4059 4.7395 12.176 4.7395 11.9362C4.7395 11.6964 4.83195 11.4664 4.9965 11.2968C5.16106 11.1272 5.38425 11.032 5.61699 11.0319L10.1808 11.0319C10.6653 11.0319 11.0585 11.437 11.0585 11.9362ZM28.6117 11.9362C28.6117 12.4353 28.2185 12.8404 27.734 12.8404L23.1702 12.8404C22.9374 12.8404 22.7143 12.7451 22.5497 12.5755C22.3851 12.4059 22.2927 12.176 22.2927 11.9362C22.2927 11.6964 22.3851 11.4664 22.5497 11.2968C22.7143 11.1273 22.9374 11.032 23.1702 11.0319L27.734 11.0319C28.2185 11.0319 28.6117 11.437 28.6117 11.9362ZM25.8706 3.24809C26.035 3.41764 26.1274 3.64753 26.1274 3.88721C26.1274 4.1269 26.035 4.35678 25.8706 4.52634L22.0622 8.45081C21.9807 8.53479 21.884 8.6014 21.7775 8.64685C21.671 8.6923 21.5568 8.71569 21.4415 8.71569C21.3263 8.71569 21.2121 8.6923 21.1056 8.64685C20.9991 8.6014 20.9024 8.53479 20.8209 8.45081C20.7394 8.36683 20.6747 8.26713 20.6306 8.15741C20.5865 8.04769 20.5638 7.93008 20.5638 7.81132C20.5638 7.69256 20.5865 7.57495 20.6306 7.46523C20.6747 7.35551 20.7394 7.25581 20.8209 7.17183L24.6292 3.24809C24.7107 3.16409 24.8075 3.09747 24.914 3.05201C25.0205 3.00655 25.1346 2.98315 25.2499 2.98315C25.3652 2.98315 25.4793 3.00655 25.5858 3.05201C25.6923 3.09747 25.7891 3.16409 25.8706 3.24809ZM8.18257 3.24809C8.26407 3.16409 8.36083 3.09746 8.46733 3.05201C8.57383 3.00655 8.68797 2.98315 8.80325 2.98315C8.91852 2.98315 9.03267 3.00655 9.13917 3.05201C9.24567 3.09746 9.34243 3.16409 9.42393 3.24809L13.2323 7.17183C13.3969 7.34143 13.4894 7.57146 13.4894 7.81132C13.4894 8.05117 13.3969 8.2812 13.2323 8.45081C13.0677 8.62041 12.8444 8.71569 12.6116 8.71569C12.3788 8.71569 12.1555 8.62041 11.9909 8.45081L8.18257 4.52634C8.01814 4.35678 7.92578 4.1269 7.92578 3.88721C7.92578 3.64753 8.01814 3.41764 8.18257 3.24809ZM17.0266 1.07417e-06C17.511 1.11652e-06 17.9042 0.405107 17.9042 0.904256L17.9042 5.60638C17.9042 5.84618 17.8117 6.07613 17.6471 6.24568C17.4825 6.41522 17.2593 6.51047 17.0266 6.51047C16.7938 6.51047 16.5706 6.41522 16.406 6.24568C16.2414 6.07613 16.149 5.84618 16.1489 5.60638L16.1489 0.904256C16.1489 0.405107 16.5421 1.03182e-06 17.0266 1.07417e-06Z" fill="white" />
//         </g>
//         <defs>
//           <clipPath id="clip0_952_680">
//             <rect width="33" height="34" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     </div>
//   )
// }

const Header = () => {
  const [showSearchInput] = useState(false)

  const isMobile = checkMobile()
  // const isImgto3d = useRecoilValue(isImgto3dAtom);


  return (
    <header className={style.headerWrapper}>
      {/* {isImgto3d ? null : (
        <SearchBox
          showSearchInput={showSearchInput}
          setShowSearchInput={setShowSearchInput} />
      )} */}
      <Restricted to="nav.index.view">
        {isMobile && (
            <Nav />
        )}
      </Restricted>
      <BalanceComponent showSearchInput={showSearchInput} />
      <UserComponent />
    </header>
  )
}

export default Header